import React from 'react';
import styled from "styled-components";
import {colors} from "../../maps/colors";
import ShowPrice from "../ShowPrice";
import {hasRTLCharacters} from "../../utils";

const WrapperStyled = styled.div`
  background-color: rgb(255, 255, 255);
  color: rgb(33, 43, 54);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  overflow: hidden;
  box-shadow: rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px;
  border-radius: 12px;
  position: relative;
  height:140px;
  display: grid;
  grid-template-columns: auto 3fr;

  img {
    height: 120px;
  }

  h3 {
    font-size: 14px;
    padding: 4px 6px 0;
    margin: 0 0 9px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    direction: ltr;
    text-align: left;

    &.rtl {
      direction: rtl;
      text-align: right;
    }
  }
`;

const InfoStyled = styled.div`
  display: grid;
  grid-template-columns: 70px 85px;
  padding: 0 7px;
  justify-content: end;

  .product-info-label {
    color: ${colors.LIGHT_GRAY};
    font-size: 11px;
    margin-right: 3px;
  }
`;

const InfoCountStyled = styled.div`
  text-align: left;
`;

const InfoPriceStyled = styled.div`
  text-align: right;
`;
const RightSideStyled = styled.div`
  text-align: right;
  width: 100%;
  overflow: hidden;
`;

const ProductInCartRow = ({product}) => {
    return (
        <WrapperStyled>
            <img src={product.imageUrl} alt={product.name} style={{height: 140}}/>
            <RightSideStyled>
                <h3 className={hasRTLCharacters(product.name) ? "rtl" : "ltr"}>{product.name}</h3>
                <InfoStyled>
                    <InfoCountStyled>
                    <span className="product-info-label">
                        Quantity
                    </span>
                        {product.quantity || 1}
                    </InfoCountStyled>
                    <InfoPriceStyled>
                    <span className="product-info-label">
                        Price
                    </span>
                        <ShowPrice price={product.price}/>
                    </InfoPriceStyled>
                </InfoStyled>
            </RightSideStyled>
        </WrapperStyled>
    );
};


export default ProductInCartRow;